import { environment } from '@environment';

export const widgetsApi = {
  alerts: {
    get_user_alerts: `${environment.api.travel_alerts}/alerts`,
    get_alert: `${environment.api.travel_alerts}/alerts/byid/{id}`,
    create_alert: `${environment.api.travel_alerts}/alerts/save`,
    delete_alert: `${environment.api.travel_alerts}/alerts/delete`,
    searches: {
      create_alert_search: `${environment.api.travel_alerts}/searches/add`,
    }
  },
};
